const loadingReducer = (state = {}, action) => {
  const { type } = action
  const level = action.payload ? action.payload.level : ''

  const matches = /(.*)_(REQUESTED|SUCCESS)/.exec(type)

  if (level && level === 'error') {
    return {
      isFetching: false
    }
  }
  // not a *_REQUEST / *_SUCCESS actions, so we ignore them
  if (!matches) return state

  const [, requestName, requestState] = matches
  return {
    ...state,
    [requestName]: requestState === 'REQUESTED'
  }
}

export default loadingReducer
